import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AccountServices from '../../modules/account/services/AccountServices';

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (AccountServices.isAuthenticated()) {
          if (rest.profile && rest.profile !== AccountServices.getRole()) {
            return <Redirect to={'/pagina-nao-encontrada'} />;
          }
          return <Component {...rest} {...props} />;
        }

        const {
          location: { pathname },
        } = props;
        return <Redirect to={`/conta/login?continue=${encodeURIComponent(pathname)}`} />;
      }}
    />
  );
};

export default PrivateRoute;
